import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { BracketContainer, InfoAreaContainer } from './styled-components';
import TileWidget from './TileWidget';

import formatGestationalAges from '../utils/format-gestational-age';
import ActionButtons from './ActionButtons';

interface Props {
  onCancelClick?: () => void;
  gestationalAgeInDays: number;
  estimatedDueDate: Date;
}

const LMPEntered = ({ onCancelClick, gestationalAgeInDays, estimatedDueDate }: Props) => (
  <TileWidget>
    <GestionalAgeContainer>
      You are now...
      <StyledBracketContainer bracketWidth="18px" bracketHeight="45px">
        {formatGestationalAges(gestationalAgeInDays)}
      </StyledBracketContainer>
      into your pregnancy!
    </GestionalAgeContainer>
    <StyledInfoAreaContainer>
      <BracketContainer bracketWidth="26px" bracketHeight="61px">
        <EstimatedDueDateContainer>
          Estimated Due Date
          <span>{moment(estimatedDueDate).format('MMM D')}</span>
        </EstimatedDueDateContainer>
      </BracketContainer>
    </StyledInfoAreaContainer>
    These dates will change.
    <ActionButtons onCancelClick={onCancelClick} />
  </TileWidget>
);

export default LMPEntered;

const StyledBracketContainer = styled(BracketContainer)``;
const GestionalAgeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 12px auto 24px; auto;
  text-align: center;
  font-size: 14px;
  ${({ theme }) => theme.fonts.FoundersGrotesk};

  ${StyledBracketContainer} {
    margin: 2px; 0;
    font-size: 27px;
    ${({ theme }) => theme.fonts.DomaineDisplay};
  }
`;

const StyledInfoAreaContainer = styled(InfoAreaContainer)`
  margin-top: 0px;
  margin-bottom: 12px;
  padding: 20px 42px;
`;

const EstimatedDueDateContainer = styled.div`
  margin: 0 22px;
  text-align: center;
  font-size: 14px;
  line-height: 18px;

  span {
    display: block;
    font-size: 24px;
    line-height: 37px;
    ${({ theme }) => theme.fonts.DomaineDisplay};
  }
`;
